import type {
  IAnnouncement,
  IAnnouncementCategory,
  IAnnouncementReaction,
  IAnnouncementUserDisplay,
} from '@/types/Data'
import type {
  IGetAnnouncement,
  IGetAnnouncementUserDisplayList,
  IPayloadAnnouncement,
  IPayloadAnnouncementCategory,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class AnnouncementServices extends BaseService {
  GetAnnouncementList(payload: IGetAnnouncement) {
    return this.GET<IAnnouncement[]>(this.PATHS.GET_ANNOUNCEMENT_LIST, payload)
  }

  CreateAnnouncement(payload: IPayloadAnnouncement) {
    return this.POST<IAnnouncement>(this.PATHS.CREATE_ANNOUNCEMENT, JsonToFormData(payload))
  }

  UpdateAnnouncement(payload: IPayloadAnnouncement) {
    return this.POST<IAnnouncement>(this.PATHS.UPDATE_ANNOUNCEMENT, JsonToFormData(payload))
  }

  DeleteAnnouncement(id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_ANNOUNCEMENT, { id })
  }

  GetAnnouncementUserDisplayList(payload: IGetAnnouncementUserDisplayList) {
    return this.GET<IAnnouncementUserDisplay[]>(
      this.PATHS.GET_ANNOUNCEMENT_USER_DISPLAY_LIST,
      payload,
    )
  }

  GetAnnouncementCategoryList() {
    return this.GET<IAnnouncementCategory[]>(this.PATHS.GET_ANNOUNCEMENT_CATEGORY_LIST)
  }

  CreateAnnouncementCategory(payload: IPayloadAnnouncementCategory) {
    return this.POST<void>(this.PATHS.CREATE_ANNOUNCEMENT_CATEGORY, payload)
  }

  UpdateAnnouncementCategory(payload: IPayloadAnnouncementCategory) {
    return this.POST<void>(this.PATHS.UPDATE_ANNOUNCEMENT_CATEGORY, payload)
  }

  DeleteAnnouncementCategory(id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_ANNOUNCEMENT_CATEGORY, null, { id })
  }

  GetAnnouncementReactions(announcementId: string) {
    return this.GET<IAnnouncementReaction[]>(this.PATHS.GET_ANNOUNCEMENT_REACTIONS, {
      announcementId,
    })
  }

  GetAnnouncementExcel() {
    return this.EXCEL(this.PATHS.GET_ANNOUNCEMENT_EXCEL, false, null)
  }
}
